// extracted by mini-css-extract-plugin
export var container = "ClosedNonParticipant_container__WE2nJ";
export var faHandHoldingBox = "ClosedNonParticipant_faHandHoldingBox__eGOqq fontawesome_min_fa-hand-holding-box__viBog";
export var fal = "ClosedNonParticipant_fal__Cdh5Q fa-light_min_fal__ABekM fontawesome_min_fal__-+-vD";
export var header = "ClosedNonParticipant_header__uCmYc";
export var icon = "ClosedNonParticipant_icon__tqx02 fontawesome_min_fa-hand-holding-box__viBog";
export var info = "ClosedNonParticipant_info__GqZDo";
export var mobile = "ClosedNonParticipant_mobile__KjbS2";